import { render, staticRenderFns } from "./UpdateStatusNotification.vue?vue&type=template&id=1d418cb5&"
import script from "./UpdateStatusNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports